export enum NotificationEnum {
    Success = 'success',
    Error = 'error',
    Warning = 'warning',
    Info = 'info',
    CouponApplied = 'couponApplied',
    LoginSuccessfullyUpdated = 'loginSuccessfullyUpdated',
    RegisterSuccessfullyUpdated = 'registerSuccessfullyUpdated',
    LogoutSuccessfullyUpdated = 'logoutSuccessfullyUpdated',
    ChangePasswordSuccessfullyUpdated = 'changePasswordSuccessfullyUpdated',
    ResetPasswordSuccessfullyUpdated = 'resetPasswordSuccessfullyUpdated',
    UpdateCompleteSuccessfullyUpdated = 'updateCompleteSuccessfullyUpdated',
    UpdateSuccessfullyUpdated = 'updateSuccessfullyUpdated',
    UpdateError = 'updateError',
    AccountCreatedSuccessfully = 'accountCreatedSuccessfully',
    RemoveAddress = 'removeAddress',
    RemoveAddressFailure = 'removeAddressFailure',
    ClientAddressRemoveSuccessfully = 'clientAddressRemoveSuccessfully',
    CreateAddress = 'createAddress',
    CreateAddressFailure = 'createAddressFailure',
    ClientAddressCreateSuccessfully = 'clientAddressCreateSuccessfully',
    UpdateUser = 'updateUser',
    UserUpdateSuccessfully = 'userUpdateSuccessfully',
    ErrorUpdatingUser = 'errorUpdatingUser',
    ClientAddressUpdateSuccessfully = 'clientAddressUpdateSuccessfully',
    OrderCreatedSuccessfully = 'orderCreatedSuccessfully',
    OrderPlaced = 'orderPlaced',
    EmailSentSuccessfully = 'emailSentSuccessfully',
    SubcribeNotificationFailure = 'subcribeNotificationFailure',
    NetworkError = 'networkError',
    UnknownError = 'unknownError',
    ErrorCreatingAddress = 'errorCreatingAddress',
    ErrorUpdatingAddress = 'errorUpdatingAddress',
    ErrorRemovingAddress = 'errorRemovingAddress',
    ErrorCreatingUser = 'errorCreatingUser',
    ErrorRemovingUser = 'errorRemovingUser',
    ErrorCreatingOrder = 'errorCreatingOrder',
    ErrorUpdatingOrder = 'errorUpdatingOrder',
    ErrorRemovingOrder = 'errorRemovingOrder',
    ErrorCreatingPayment = 'errorCreatingPayment',
    ErrorUpdatingPayment = 'errorUpdatingPayment',
    ErrorRemovingPayment = 'errorRemovingPayment',
    ErrorCreatingCoupon = 'errorCreatingCoupon',
    ErrorUpdatingCoupon = 'errorUpdatingCoupon',
    ErrorRemovingCoupon = 'errorRemovingCoupon',
    ErrorCreatingClient = 'errorCreatingClient',
    ErrorUpdatingClient = 'errorUpdatingClient',
    ErrorRemovingClient = 'errorRemovingClient',
    ErrorCreatingStore = 'errorCreatingStore',
    ErrorUpdatingStore = 'errorUpdatingStore',
    ErrorRemovingStore = 'errorRemovingStore',
    ErrorCreatingProduct = 'errorCreatingProduct',
    ErrorUpdatingProduct = 'errorUpdatingProduct',
    ErrorRemovingProduct = 'errorRemovingProduct',
    ErrorCreatingCategory = 'errorCreatingCategory',
    ErrorUpdatingCategory = 'errorUpdatingCategory',
    ErrorRemovingCategory = 'errorRemovingCategory',
    ErrorCreatingSubcategory = 'errorCreatingSubcategory',
    ErrorUpdatingSubcategory = 'errorUpdatingSubcategory',
    ErrorRemovingSubcategory = 'errorRemovingSubcategory',
    ErrorCreatingTip = 'errorCreatingTip',
    ErrorUpdatingTip = 'errorUpdatingTip',
    ErrorRemovingTip = 'errorRemovingTip',
    ErrorCreatingTax = 'errorCreatingTax',
    ErrorUpdatingTax = 'errorUpdatingTax',
    ErrorRemovingTax = 'errorRemovingTax',
    ErrorCreatingDeliveryZone = 'errorCreatingDeliveryZone',
    ErrorUpdatingDeliveryZone = 'errorUpdatingDeliveryZone',
    ErrorRemovingDeliveryZone = 'errorRemovingDeliveryZone',
    ErrorCreatingDeliveryZoneCustomer = 'errorCreatingDeliveryZoneCustomer',
    ErrorUpdatingDeliveryZoneCustomer = 'errorUpdatingDeliveryZoneCustomer',
    ErrorRemovingDeliveryZoneCustomer = 'errorRemovingDeliveryZoneCustomer',
    ErrorCreatingDeliveryZoneCustomerLocation = 'errorCreatingDeliveryZoneCustomerLocation',
    ErrorUpdatingDeliveryZoneCustomerLocation = 'errorUpdatingDeliveryZoneCustomerLocation',
    ErrorRemovingDeliveryZoneCustomerLocation = 'errorRemovingDeliveryZoneCustomerLocation',
    Failure = 'failure',
    // Nuevos enums para checkout
    NotInDeliveryZone = 'notInDeliveryZone',
    DataNotAvailable = 'dataNotAvailable',
    ErrorCheckingStoreHours = 'errorCheckingStoreHours',
    StoreIsClosed = 'storeIsClosed',
    PaymentFailed = 'paymentFailed',
    NetworkErrorOccurred = 'networkErrorOccurred',
    // Nuevos enums para modal de éxito
    OrderPlacedTitle = 'orderPlacedTitle',
    OrderPlacedMessage = 'orderPlacedMessage',
    ContinueInStore = 'continueInStore',
    CloseStore = 'closeStore',
    // Nuevos enums para dia-laboral service
    StoreClosedTitle = 'storeClosedTitle',
    StoreClosedMessage = 'storeClosedMessage',
    LeaveTheStore = 'leaveTheStore',
    OrderTypeNotAvailableTitle = 'orderTypeNotAvailableTitle',
    OrderTypeNotAvailableMessage = 'orderTypeNotAvailableMessage',
    ChangeToOrderType = 'changeToOrderType',

    OrderTypeNotAvailableTitlePickup = 'orderTypeNotAvailableTitlePickup',
    OrderTypeNotAvailableMessagePickup = 'orderTypeNotAvailableMessagePickup',
    OrderTypeNotAvailableTitleDelivery = 'orderTypeNotAvailableTitleDelivery',
    OrderTypeNotAvailableMessageDelivery = 'orderTypeNotAvailableMessageDelivery',

    ChangeToOrderTypePickup = 'changeToOrderTypePickup',
    ChangeToOrderTypeDelivery = 'changeToOrderTypeDelivery',
    Understand = 'understand',
    CouponNotApplicable = 'couponNotApplicable'
}
